// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "850e8f71" + "." + "11f8303dccaf10cf135b" + ".js";
};